export default (hours, colors) => {
  if (!hours || !hours.length || !colors || !colors.length) {
    return [0, 0];
  }

  // If an hour is null, that means there is no data for that hour.
  // However, Math.max() and Math.min() treat nulls as zeroes.
  // Filter null values from the data before calculating min and max:
  const filteredHours = hours.filter((hour) => hour !== null);
  const min = Math.min(...filteredHours);
  const max = Math.max(...filteredHours);
  const range = max - min;
  const step = range / (colors.length - 1);
  return colors.map((color, index) => min + step * index);
};
